// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yc_pN9LY9KWFeCssdxRf{margin-bottom:10px}@media print{.yc_pN9LY9KWFeCssdxRf{margin-bottom:0}}.yc_pN9LY9KWFeCssdxRf .WNPzoZJxxCiCexyZxG9t{color:#000;font-size:14px;font-weight:bold;text-transform:uppercase}.yc_pN9LY9KWFeCssdxRf p{margin-bottom:0}.yc_pN9LY9KWFeCssdxRf ul{padding-left:18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `yc_pN9LY9KWFeCssdxRf`,
	"title": `WNPzoZJxxCiCexyZxG9t`
};
module.exports = ___CSS_LOADER_EXPORT___;
